var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrgPlant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 64,
    viewBox: "0 0 47 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5889 44.5213H13.8242V50.0864H16.5889V44.5213Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5889 38.9559H13.8242V41.7385H16.5889V38.9559Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9705 25.8033V22.2597H1.38234C0.620672 22.2597 0 22.8844 0 23.651V36.1725H6.21639C7.86415 31.2154 12.3609 27.3615 17.9705 25.8033Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2657 25.2356V22.2597H20.7363V25.2356C21.6418 25.1146 22.5638 25.0422 23.501 25.0422C24.4396 25.0422 25.3603 25.1146 26.2657 25.2356Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9561 19.478L38.706 3.71056V0H8.29444V3.71056L20.0444 19.478H26.9561Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9722 28.6969C13.9178 30.0088 10.6651 32.7191 9.17773 36.1722H17.9722V28.6969Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0587 38.9559H0V41.7385H11.0587V38.9559Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0293 28.6969V36.1736H37.8238C36.3364 32.7191 33.0851 30.0088 29.0293 28.6969Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1768 44.5213H30.4121V50.0864H33.1768V44.5213Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1768 38.9559H30.4121V41.7385H33.1768V38.9559Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7363 36.1728H26.2657V28.0379C25.3658 27.9002 24.4424 27.8251 23.501 27.8251C22.5596 27.8251 21.6362 27.9002 20.7363 28.0379V36.1728Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6476 38.9559H19.3535V41.7385H27.6476V38.9559Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6476 44.5213H19.3535V50.0864H27.6476V44.5213Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0587 44.5213H0V62.608C0 63.376 0.620672 63.9993 1.38234 63.9993H8.29405V50.0864H11.0587V44.5213Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0293 25.8033C34.6416 27.3615 39.137 31.214 40.7834 36.1725H46.9997V22.2597H29.0293V25.8033Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0001 38.9559H35.9414V41.7385H47.0001V38.9559Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9408 52.8694H11.0586V63.9997H35.9408V52.8694Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9414 50.0864H38.7061V63.9993H47.0001V44.5213H35.9414V50.0864Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgPlant);
export default __webpack_public_path__ + "static/media/org-plant.732f25e13a89368e43cbbb8140c1ce5b.svg";
export { ForwardRef as ReactComponent };